import React, { useState, useContext, useEffect } from "react";
import "./Expenses.css";
import AuthContext from "../store/auth-context";

function Expenses() {
  const [enteredTitle, setEnteredTitle] = useState("");
  const [enteredAmount, setEnteredAmount] = useState();
  const [CatTitle, setCatTitle] = useState("");
  const [CatTotal, setCatTotal] = useState(0);
  const [newExpenseAmount, setNewExpenseAmount] = useState("");

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    authCtx.setTotalExpense(0);
    getCategory();
  }, []);

  function createDbCategory() {
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/expenses.json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        title: CatTitle,
        expenses: [],
      }),
      header: { "Content/type": "application/json" },
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        let c = {
          title: CatTitle,
          expenses: [],
          id: res["name"],
          categoryTotal: 0,
        };
        authCtx.setExpenses((prevExpenses) => {
          return [c, ...prevExpenses];
        });
      });
  }
  function getCategory() {
    authCtx.setExpenses([]);
    authCtx.setTotalExpense(0);
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/expenses.json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "GET",
      header: { "Content/type": "application/json" },
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        for (const catgeory in res) {
          let exp = [];
          let total = 0;
          for (const x in res[catgeory]) {
            if (res[catgeory][x] != "title") {
              const e = {
                expenseTitle: res[catgeory][x].expenseTitle,
                expenseAmount: res[catgeory][x].expenseAmount,
                expenseID: x,
              };
              if (e.expenseAmount) {
                total += parseFloat(e.expenseAmount);
              }
              exp.push(e);
            }
          }
          let c = {
            title: res[catgeory].title,
            expenses: exp,
            categoryTotal: parseFloat(total),
            open: true,
            id: catgeory,
          };
          authCtx.setExpenses((prevExpenses) => {
            return [c, ...prevExpenses];
          });
          authCtx.setTotalExpense((prev) => {
            return prev + c.categoryTotal;
          });
        }
      });
  }
  function deleteCategory(id) {
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/expenses/" +
      id +
      ".json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "DELETE",
      header: { "Content/type": "application/json" },
    }).then(() => {
      let expenses = [];
      for (let i = 0; i < authCtx.expenses.length; i++) {
        if (authCtx.expenses[i].id != id) {
          let c = {
            id: authCtx.expenses[i].id,
            title: authCtx.expenses[i].title,
            expenses: authCtx.expenses[i].expenses,
            categoryTotal: parseFloat(authCtx.expenses[i].categoryTotal),
          };
          expenses.push(c);
        } else {
          authCtx.setTotalExpense((prev) => {
            return prev - authCtx.expenses[i].categoryTotal;
          });
        }
      }
      authCtx.setExpenses(expenses);
    });
  }
  function addExpense(id) {
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/expenses/" +
      id +
      ".json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        expenseTitle: enteredTitle,
        expenseAmount: enteredAmount,
      }),
      header: { "Content/type": "application/json" },
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        let expenses = [];
        let e = { expenseTitle: enteredTitle, expenseAmount: enteredAmount };
        //if not the right category just copy
        for (let i = 0; i < authCtx.expenses.length; i++) {
          if (authCtx.expenses[i].id != id) {
            let c = {
              id: authCtx.expenses[i].id,
              title: authCtx.expenses[i].title,
              expenses: [...authCtx.expenses[i].expenses],
              categoryTotal: parseFloat(authCtx.expenses[i].categoryTotal),
            };
            expenses.push(c);
          } else {
            //else prepend the new expense
            let c = {
              id: authCtx.expenses[i].id,
              title: authCtx.expenses[i].title,
              expenses: [e, ...authCtx.expenses[i].expenses],
              categoryTotal:
                parseFloat(authCtx.expenses[i].categoryTotal) +
                parseFloat(e.expenseAmount),
            };
            expenses.push(c);
            authCtx.setTotalExpense((prev) => {
              return prev + parseFloat(e.expenseAmount);
            });
          }
        }
        authCtx.setExpenses(expenses);
      });
  }
  function deleteExpense(cat, id) {
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/expenses/" +
      cat +
      "/" +
      id +
      ".json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "DELETE",
      header: {
        "Content/type": "application/json",
      },
    }).then(() => {
      let expenses = [];
      for (let i = 0; i < authCtx.expenses.length; i++) {
        //right category
        if (authCtx.expenses[i].id == cat) {
          //right expense?
          let exp = [];
          let a;
          for (let j = 0; j < authCtx.expenses[i].expenses.length; j++) {
            if (authCtx.expenses[i].expenses[j].expenseID != id) {
              //push it
              let e = {
                expenseAmount: parseFloat(
                  authCtx.expenses[i].expenses[j].expenseAmount
                ),
                expenseTitle: authCtx.expenses[i].expenses[j].expenseTitle,
                expenseID: authCtx.expenses[i].expenses[j].expenseID,
              };
              exp.push(e);
            } else {
              a = parseFloat(authCtx.expenses[i].expenses[j].expenseAmount);
              authCtx.setTotalExpense((prev) => {
                return prev - a;
              });
            }
          }
          let c = {
            id: authCtx.expenses[i].id,
            title: authCtx.expenses[i].title,
            expenses: [...exp],
            categoryTotal: parseFloat(authCtx.expenses[i].categoryTotal) - a,
          };
          expenses.push(c);
        } else {
          let c = {
            id: authCtx.expenses[i].id,
            title: authCtx.expenses[i].title,
            expenses: [...authCtx.expenses[i].expenses],
            categoryTotal: parseFloat(authCtx.expenses[i].categoryTotal),
          };
          expenses.push(c);
        }
      }
      authCtx.setExpenses(expenses);
    });
  }
  function editExpense(event, cat, id, title) {
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/expenses/" +
      cat +
      "/" +
      id +
      ".json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "PATCH",
      body: JSON.stringify({
        expenseTitle: title,
        expenseAmount: newExpenseAmount,
      }),
      header: {
        "Content/type": "application/json",
      },
    }).then(() => {
      let expenses = [];
      let a;
      let b;
      for (let i = 0; i < authCtx.expenses.length; i++) {
        if (authCtx.expenses[i].id == cat) {
          let exp = [];
          for (let j = 0; j < authCtx.expenses[i].expenses.length; j++) {
            if (authCtx.expenses[i].expenses[j].expenseID != id) {
              let ex = {
                expenseTitle: authCtx.expenses[i].expenses[j].expenseTitle,
                expenseAmount: parseFloat(
                  authCtx.expenses[i].expenses[j].expenseAmount
                ),
                expenseID: authCtx.expenses[i].expenses[j].expenseID,
              };
              exp.push(ex);
              b = ex.expenseAmount;
            } else {
              a = parseFloat(authCtx.expenses[i].expenses[j].expenseAmount);
              let ex = {
                expenseTitle: title,
                expenseAmount: parseFloat(newExpenseAmount),
                expenseID: authCtx.expenses[i].expenses[j].expenseID,
              };
              exp.push(ex);
              setCatTotal(CatTotal + ex.expenseAmount);
            }
          }
          let c = {
            id: authCtx.expenses[i].id,
            title: authCtx.expenses[i].title,
            expenses: exp,
            categoryTotal:
              authCtx.expenses[i].categoryTotal -
              a +
              parseFloat(newExpenseAmount),
          };
          authCtx.setTotalExpense((prev) => {
            return (
              parseFloat(prev) -
              parseFloat(authCtx.expenses[i].categoryTotal) +
              parseFloat(c.categoryTotal)
            );
          });
          expenses.push(c);
        } else {
          let c = {
            id: authCtx.expenses[i].id,
            title: authCtx.expenses[i].title,
            expenses: [...authCtx.expenses[i].expenses],
            categoryTotal: parseFloat(authCtx.expenses[i].categoryTotal),
          };
          expenses.push(c);
        }
      }
      authCtx.setExpenses(expenses);
    });
  }
  function newExpenseAmountHandler(event) {
    setNewExpenseAmount(event.target.value);
  }
  function titleChangeHandler(event) {
    setEnteredTitle(event.target.value);
  }
  function amountChangeHandler(event) {
    setEnteredAmount(event.target.value);
  }
  function CatsubmitHandler(event) {
    event.preventDefault();
    createDbCategory();
    setCatTitle("");
  }
  function CatTitleChangeHandler(event) {
    setCatTitle(event.target.value);
  }

  return (
    <>
      <div className="container addCat">
        <h2 className="text-center enter">Add An Expense Category!</h2>
        <div className="row">
          <div className="addCategory">
            <form onSubmit={CatsubmitHandler}>
              <div className="form-group">
                <label className="catLab">Category name</label>
                <p className="createCategoryI">
                  <input
                    required
                    class="form-control createCategoryInput"
                    placeholder="Housing"
                    type="text"
                    value={CatTitle}
                    onChange={CatTitleChangeHandler}
                  ></input>
                </p>
              </div>
              <div className="catSubmitDiv">
                <br></br>
                <br></br>
                <button
                  type="submit"
                  className="btn btn-primary mb-2 catSubmit"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="container expensesCont">
        <div className="row">
          <div id="divExpn">
            <h1 className="myExp">Your Expenses:</h1>
            <div>
              {authCtx.expenses.length == 0 ? (
                <h2 className="text-center">
                  Enter Your First Expense Category!
                </h2>
              ) : (
                authCtx.expenses.map((expense) => (
                  <div className="container-fluid expenseItem">
                    <div className="row">
                      <div id="example-collapse-text">
                        <p className="nameCont">
                          <h2 className="expenseName">{expense.title}</h2>
                        </p>
                        <div>
                          {
                            // empty expenses list? -> add conditional
                            expense.expenses.map(
                              (expenseObj) =>
                                expenseObj.expenseTitle &&
                                expenseObj.expenseTitle != "" && (
                                  <form
                                    onSubmit={(event) => {
                                      event.preventDefault();
                                      if (newExpenseAmount) {
                                        editExpense(
                                          event,
                                          expense.id,
                                          expenseObj.expenseID,
                                          expenseObj.expenseTitle
                                        );
                                        event.target.quantityNewExpense.value =
                                          "";
                                        setNewExpenseAmount("");
                                      }
                                    }}
                                  >
                                    <span>
                                      <p id="expenseItem">
                                        <label className="labelExpense">
                                          {expenseObj.expenseTitle}: $
                                          {expenseObj.expenseAmount}
                                        </label>
                                        <input
                                          type="number"
                                          required
                                          id="quantityNewExpense"
                                          name="quantityNewExpense"
                                          min="0"
                                          className="editExpense"
                                          onChange={newExpenseAmountHandler}
                                        ></input>
                                        <button
                                          type="submit"
                                          class="btn btn-secondary editExpenseButton"
                                        >
                                          Edit
                                        </button>
                                        <svg
                                          onClick={(event) => {
                                            event.preventDefault();
                                            deleteExpense(
                                              expense.id,
                                              expenseObj.expenseID
                                            );
                                          }}
                                          className="trashIconExp"
                                          fill="#1A1A1A"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          width="20px"
                                          height="20px"
                                        >
                                          <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" />
                                        </svg>
                                      </p>
                                    </span>
                                  </form>
                                )
                            )
                          }
                        </div>
                        <form
                          onSubmit={(event) => {
                            event.preventDefault();
                            if (enteredAmount && enteredTitle) {
                              addExpense(expense.id);
                              event.target.newExpenseName.value = "";
                              event.target.newExpenseValue.value = "";
                              setEnteredAmount("");
                              setEnteredTitle("");
                            }
                          }}
                        >
                          <div className="form-group">
                            <span>
                              <label>Expense Name</label>
                              <input
                                type="text"
                                name="newExpenseName"
                                required
                                class="form-control col-md-1"
                                placeholder="Expense"
                                onChange={titleChangeHandler}
                              ></input>
                            </span>
                            <span>
                              <label>Expense Amount</label>
                              <input
                                type="number"
                                required
                                name="newExpenseValue"
                                class="form-control col-md-1"
                                min="0"
                                placeholder="$1000"
                                onChange={amountChangeHandler}
                              ></input>
                            </span>
                            <p className="buttondiv">
                              <button
                                type="submit"
                                required
                                className="btn btn-primary mb-2 expSubmit"
                              >
                                Add
                              </button>
                            </p>
                          </div>
                        </form>
                        <br></br>
                        <span>
                          <h2>
                            Total: ${parseFloat(expense.categoryTotal) || 0}
                          </h2>
                          <svg
                            onClick={() => {
                              deleteCategory(expense.id);
                            }}
                            className="trashIcon"
                            fill="#1A1A1A"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="48px"
                            height="48px"
                          >
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <hr className="dividor"></hr>
                  </div>
                ))
              )}
            </div>
            {authCtx.totalExpense > 0 && (
              <h2>Total Expenses: ${authCtx.totalExpense} </h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Expenses;
